export default "__VITE_ASSET__ueIQdcee__"